// (c) chaehongee. Confidential and proprietary.

import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { useModalDialog } from '../../hooks/useModalDialog'
import styles from './SessionExpiredModal.module.css'

interface SessionExpiredModalProps {
    onClose: () => void
}

export function SessionExpiredModal({ onClose }: SessionExpiredModalProps) {
    const { t } = useTranslation('auth')

    // Focus trap + Escape-to-close + focus return. This modal mounts only
    // when shown, so it is always "open" while rendered.
    const { dialogRef } = useModalDialog<HTMLDivElement>(true, onClose)

    return (
        <>
            <div className={styles.backdrop} onClick={onClose} aria-hidden="true" />

            <div
                ref={dialogRef}
                className={styles.modal}
                role="dialog"
                aria-labelledby="session-expired-title"
                aria-modal="true"
                tabIndex={-1}
            >
                <button
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label={t('common:close')}
                >
                    <X className={styles.closeIcon} aria-hidden="true" />
                </button>
                <div className={styles.modalContent}>
                    <h1 id="session-expired-title" className={styles.title}>
                        {t('sessionExpired')}
                    </h1>
                    <p className={styles.description}>
                        {t('sessionExpiredDescription')}
                    </p>
                    <button
                        className={styles.submitButton}
                        onClick={onClose}
                    >
                        {t('logInAgain')}
                    </button>
                </div>
            </div>
        </>
    )
}
